import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useAppSelector } from './hooks';
import { store } from './store/store';
import { AuthBoundary } from './components/AuthBoundary';
import GlobalErrorDialog from './components/GlobalErrorDialog';
import { router } from './router';

const AppContent: React.FC = () => {
  const isErrorDialogOpen = useAppSelector((s) => s.globalError.isOpen);

  return (
    <>
      <AuthBoundary>
        <RouterProvider router={router} />
      </AuthBoundary>
      {isErrorDialogOpen && <GlobalErrorDialog />}
    </>
  );
};

const App: React.FC = () => (
  <Provider store={store}>
    <AppContent />
  </Provider>
);

export default App;
